"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class SubscriptionParams {
    constructor(copyFrom) {
        this.deviceId = copyFrom.deviceId || copyFrom.targetDevice;
        this.applicationId = copyFrom.applicationId;
        this.transport = copyFrom.transport;
        this.topic = copyFrom.topic;
        this.subjectFilter = copyFrom.subjectFilter;
        this.methodFilter = copyFrom.methodFilter;
        this.publicationFilter = copyFrom.publicationFilter;
        this.context = copyFrom.context;
        this.expiryDateTime = copyFrom.expiryDateTime;
        this.recordNotifications = copyFrom.recordNotifications;
        this.publicationTimeToLiveSeconds = copyFrom.publicationTimeToLiveSeconds;
        this.batchReceive = copyFrom.batchReceive;
        this.title = copyFrom.title;
        this.titleKey = copyFrom.titleKey;
        this.titleArgs = copyFrom.titleArgs;
        this.body = copyFrom.body;
        this.bodyKey = copyFrom.bodyKey;
        this.bodyArgs = copyFrom.bodyArgs;
        this.iconKey = copyFrom.iconKey;
        this.color = copyFrom.color;
        this.soundKey = copyFrom.soundKey;
        this.threadId = copyFrom.threadId;
        this.actionKey = copyFrom.actionKey;
    }
}
exports.SubscriptionParams = SubscriptionParams;
